'use client';

import { c as _c } from "react/compiler-runtime";
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { type CountdownState, resolveCountdownState } from '../_utils/countdown';

/**
 * 다음 가능 시각(서버 권위, epoch ms)까지 1초 단위 카운트다운 상태를 파생한다.
 * 대기 중일 때만 인터벌을 돌리고, 가능해지면(도달하면) 인터벌을 멈춘다.
 */
export const useCountdown = nextAvailableAtMs => {
  const $ = _c(6);
  const [nowMs, setNowMs] = useState(_temp);
  let t0;
  if ($[0] !== nextAvailableAtMs || $[1] !== nowMs) {
    t0 = resolveCountdownState({
      nowMs,
      nextAvailableAtMs
    });
    $[0] = nextAvailableAtMs;
    $[1] = nowMs;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const state = t0;
  let t1;
  let t2;
  if ($[3] !== state.isAvailable) {
    t1 = () => {
      if (state.isAvailable) {
        return;
      }
      const intervalId = setInterval(() => setNowMs(dayjs().valueOf()), 1000);
      return () => clearInterval(intervalId);
    };
    t2 = [state.isAvailable];
    $[3] = state.isAvailable;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return state;
};
function _temp() {
  return dayjs().valueOf();
}